import { render, staticRenderFns } from "./AdminStatistic.vue?vue&type=template&id=4a8b8a2a&scoped=true&"
import script from "./AdminStatistic.vue?vue&type=script&lang=ts&"
export * from "./AdminStatistic.vue?vue&type=script&lang=ts&"
import style0 from "./AdminStatistic.vue?vue&type=style&index=0&id=4a8b8a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8b8a2a",
  null
  
)

export default component.exports